import { render, staticRenderFns } from "./Expediente.vue?vue&type=template&id=234d2c68"
import script from "./Expediente.vue?vue&type=script&lang=js"
export * from "./Expediente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('234d2c68')) {
      api.createRecord('234d2c68', component.options)
    } else {
      api.reload('234d2c68', component.options)
    }
    module.hot.accept("./Expediente.vue?vue&type=template&id=234d2c68", function () {
      api.rerender('234d2c68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificacionesdigital/Expediente.vue"
export default component.exports